<template>
  <div v-if="mainArtist" class="artist-main-section">
    <div class="artist-main-section__col">
      <div class="artist-main-section__header">
        <div class="artist-main-section__header__item">
          <span>RESIDENT</span>
          <router-link
            :to="{
              name: 'Artist',
              params: { id: mainArtist.mainArtist.permlink }
            }"
          >
            {{ mainArtist.mainArtist.name }}
          </router-link>
        </div>
        <div
          v-if="this.$route.params.id != mainArtist.podcast.permlink"
          class="artist-main-section__header__item"
        >
          <span>HOST ON SHOW</span>
          <router-link
            :to="{
              name: 'Podcasts',
              params: { id: mainArtist.podcast.permlink }
            }"
          >
            {{ mainArtist.podcast.name }}
          </router-link>
        </div>
      </div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="artist-main-section__body" v-html="mainArtist.mainArtist.bio" />
    </div>
    <div class="artist-main-section__col">
      <div class="artist-main-section__image">
        <img :src="$router.options.imagePath + mainArtist.mainArtist.mediaUrl" />
      </div>
    </div>
    <div class="artist-main-section__col-mobile">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="artist-main-section__body-mobile" v-html="mainArtist.mainArtist.bio" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'EpisodeArtistSection',
  props: {
    mainArtist: {
      type: Object,
      required: true
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_episode-artist-section.scss';
</style>
